export function SectionB() {
  return (<p>Section B</p>);
}
